// extracted by mini-css-extract-plugin
module.exports = {"layout":"Domain_layout_2vZD3","main":"Domain_main_LNd1y"};